module.exports = __webpack_public_path__ + "3b9cbe85e223bbf1bce2aa99ab853c2f.jpg";